export const ROOT = '/';
export const REDIRECT = '/redirect';
export const SEARCH = '/search';
export const DASHBOARD = '/dashboard';
export const MANAGEMENT = '/management';
export const LDAP_GROUP_SELECT = '/ldap-group-select';
export const SETTINGS = '/settings';
export const USERS_SETTINGS = '/settings/users';
export const METABASE_CALLBACK = '/metabase-callback';
